import { render } from "./UnAssignedIssues.vue?vue&type=template&id=5721e1be&scoped=true"
import script from "./UnAssignedIssues.vue?vue&type=script&lang=js"
export * from "./UnAssignedIssues.vue?vue&type=script&lang=js"

import "./UnAssignedIssues.vue?vue&type=style&index=0&id=5721e1be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5721e1be"]])

export default __exports__